import { DateTime } from "luxon";

export const getCalendarDatesFromDefault = () => ["week", DateTime.now().toISODate()];
